import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Moment from 'react-moment';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../generics/help';
import LabelForm from '../../components/LabelForm';
import SelectForm from '../../components/SelectForm';
import { clinicHistoryYearsHasHc, donationTypeExtraction, equipments, pdfIMSS } from '../../libs/services';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../config');

class EquipmentTest extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.setTable = this.setTable.bind(this);
        this.onPrint = this.onPrint.bind(this);

		this.state = {
			health_facilities_id:'',
            year:'',
            init_month:'',
            equipments:[],
            equipment_id:'all',
            years:[],
            months:[
                {value:'1', text:'Enero'},
                {value:'2', text:'Febrero'},
                {value:'3', text:'Marzo'},
                {value:'4', text:'Abril'},
                {value:'5', text:'Mayo'},
                {value:'6', text:'Junio'},
                {value:'7', text:'Julio'},
                {value:'8', text:'Agosto'},
                {value:'9', text:'Septiembre'},
                {value:'10', text:'Octubre'},
                {value:'11', text:'Noviembre'},
                {value:'12', text:'Diciembre'},
            ],
			listado:[],
            columns:[[
                {title:'No.', rowSpan:2, width:'100px'},
                {title:'Equipo', rowSpan:2, width:'100px'},
                {title:'No. Serie', rowSpan:2, width:'100px'},
                {title:'T. Estudio', rowSpan:2, width:'100px'},
                {title:'Cve. Prueba', rowSpan:2, width:'100px'},
                {title:'Nombre Prueba', rowSpan:2, width:'100px'},
            ]],
			filename:"Resumen de Pruebas Realizadas por Equipo Analizador",

			date_hour:"",
			medical:"",
            start_date:"",
            end_date:"",
            month:"",
            equipment:''
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	async componentDidMount(){
        var id = sessionStorage.getItem('health_facilities_id');
        var options = [];

        var response = await equipments('analytical_test');
        if(response){
            options = response.map((res)=>{
                var obj = {
                    value:res.equipment.id,
                    text:res.equipment.name
                };

                return obj;
            });

            options.unshift({value:'all', text:'TODOS'});

            this.setState({equipments: options});
        }

        response = await clinicHistoryYearsHasHc(id);
        if(response){
            options = response.map((res)=>{
                var obj = {
                    value: res,
                    text:res
                };

                return obj;
            });

            this.setState({years: options});
        }

		//this.setTable();
	}

	setTable(){
		this.$el = $(this.el);

        var obj = {
            health_facilities_id: this.state.health_facilities_id,
            year: this.state.year,
            init_month: this.state.init_month,
            aux_id: this.state.aux_id
        };

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [                
				{
                	extend: 'excelHtml5',
                	title: this.state.filename,
                	action: (e, dt, node, config)=>{
                        this.props.printExcelReport(this.state.filename, 'daily_tests', obj);
                    }
            	},
                {
                    text:'PDF',
                    action: (e, dt, node, config)=>{
                        this.props.printPdfIMSSReports('daily_tests', obj);
                    }
                }
            ],
			//data: this.state.listado,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
			},
			paging:false,
			ordering:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.dt-button').disable();
		}else {
			table.buttons('.dt-button').enable();
		}
	}

	handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});

        setTimeout(()=>{
			if(this.state.year !== "" && this.state.init_month !== ""){
				let value = parseInt(this.state.init_month);
				let month = value < 10 ? '0'+(value) : value;
				let nextMonth = value < 10 ? '0'+(value+1) :  value === 12 ? '01' : value + 1;
				let nextYear = value === 12 ? parseInt(this.state.year) + 1 : this.state.year;
				/*this.setState({
					start_date: this.state.year+'-'+month+'-'+26,
					end_date: nextYear+'-'+nextMonth+'-'+25,
				});	*/		
			}
		}, 500);
		
		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	searching(){

		if(this.isValidForm()){
            var obj = {
                year: this.state.year,
                end_month: this.state.init_month,
                equipment_id: this.state.equipment_id
            }
            
            this.props.waiting.handleShow('Buscando...');
            fetch(Config.default.apiGateway.URL+'reports_imss/equipment_test_summary',{
                method: 'POST',
                body:JSON.stringify(obj),
                headers: new Headers({
                    'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                    'Accept'		: 'application/json',
                    'Content-Type'	: 'application/json'
                })
            }).then(res => {
                this.props.waiting.handleClose();

                if(res.ok){
                    return res.json();
                }else{
                    res.text().then((msg)=>{
                        swal('Error', msg, 'error');
                    });
                }
            }).then(async response => {
                if(response !== undefined){
                    var list = [];
                    var columns = [
                        [
                            {title:'No.', rowSpan:3, width:'50px'},
                            {title:'Equipo', rowSpan:3, width:'150px'},
                            {title:'No. Serie', rowSpan:3, width:'150px'},
                            {title:'T. Estudio', rowSpan:3, width:'150px'},
                            {title:'Cve. Prueba', rowSpan:3, width:'150px'},
                            {title:'Nombre Prueba', rowSpan:3, width:'250px'},
                            {title:'Cantidad de Pruebas Realizadas', colSpan:1, width:'1550px'}
                        ]
                    ];

                    if(response.tests.length > 0){
                        columns[0][6].colSpan = response.tests[0].details.length + 1;

                        
                        response.tests.forEach((test, i)=>{                            
                            if(i === 0){
                                let row_months = [];
                                let row_days = []
                                test.details.forEach((detail)=>{
                                    let index = row_months.findIndex(obj => obj.id === detail.month);
                                    if(index === -1){    
                                        row_months.push({
                                            title:this.state.months[detail.month - 1].text,
                                            id:detail.month,
                                            colSpan:0
                                        });
                                    }

                                    row_days.push({
                                        title:detail.day
                                    });
                                });
                                
                                row_months.forEach((r)=>{
                                    let count = 0;
                                    test.details.forEach((detail)=>{
                                        if(detail.month === r.id){
                                            count++;
                                        }
                                        
                                    });

                                    r.colSpan = count;
                                });

                                row_months.push({title:'', colSpan:1});
                                row_days.push({title:'Total'});
                                

                                columns.push(row_months, row_days);
                            }

                            let obj = [
                                i,
                                test.equipment_brand,
                                test.equipment_serial_number,
                                test.section_name,
                                test.test_cve,
                                test.test_name
                            ]
                            test.details.forEach((detail)=>{
                                obj.push(detail.total);    
                            });

                            obj.push(test.total);

                            list.push(obj);
                        });

                        let totals = [
                            'TOTAL PRUEBAS DIARIAS'
                        ];

                        response.totals.forEach(t => {
                            totals.push(t.total)
                        });
                        totals.push(response.total);

                        list.push(totals);
                    }

                    this.setState({columns:columns, listado: list, month:response.month, equipment: response.equipment_name});

                }
            });
               
			
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

    onPrint(type){
        var obj = {
            year: this.state.year,
                end_month: this.state.init_month,
                equipment_id: this.state.equipment_id
        }

        if(type === 'excel'){
            this.props.printExcelReport(this.state.filename, 'equipment_test_summary', obj);
        }else{
            this.props.printPdfIMSSReports('equipment_test_summary', obj);
        }
    }

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_imss"} 
		            submenu={"help_equipment_test_summary"}  />

				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>												
                                <div className="form-group">
                                    <LabelForm text="Años" />
                                    <SelectForm 
                                        id="year"
                                        value={this.state.year}
                                        options={this.state.years}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <LabelForm text="Mes" />
                                    <SelectForm 
                                        id="init_month"
                                        value={this.state.init_month}
                                        options={this.state.months}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <LabelForm text="Equipo" />
                                    <SelectForm 
                                        id="equipment_id"
                                        value={this.state.equipment_id}
                                        options={this.state.equipments}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>

							
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
                                    {this.state.month !== '' &&
                                        <div className="col-xs-12">
                                            <span><b>Mes: </b>{this.state.month}</span>
                                            <span style={{marginLeft:18}}><b>Equipo: </b>{this.state.equipment}</span>
                                        </div>
                                    }

								</div>

                                <div className="col-xs-12 form-group" style={{textAlign:'right'}}>
									<button type="button" className="btn btn-default" disabled={this.state.listado.length === 0} onClick={(e) => this.onPrint('excel')} style={{marginRight:8}}>Excel</button>
									<button type="button" className="btn btn-default" disabled={this.state.listado.length === 0} onClick={(e) => this.onPrint('pdf')}>PDF</button>
								</div>
								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="table expenses-discards" id="table-to-xls" 
											 ref={el => this.el = el}>
                                            <thead>
                                                {this.state.columns.map((row, i)=>
                                                    <tr key={i}>
                                                        {row.map((col, j)=>
                                                            col.rowSpan !== undefined ?
                                                                <th style={{width:col.width}} className='center' key={j} rowSpan={col.rowSpan}>{col.title}</th>
                                                            :
                                                                <th 
                                                                    className='center' 
                                                                    key={j} 
                                                                    colSpan={col.colSpan}
                                                                    style={i === 0 ? {width: col.width} : {}}
                                                                >
                                                                    {col.title}
                                                                </th>
                                                        )}
                                                    </tr>
                                                )}
                                            </thead>
                                            <tbody>
                                                {this.state.listado.map((list, i)=>
                                                    <tr key={i} className="space-table">
                                                        {list.map((l, j)=>
                                                            <>
                                                            {j === 0 && l === 'TOTAL PRUEBAS DIARIAS' ?
                                                                <td  colSpan={6} style={{textAlign:'right'}} key={j}>
                                                                    {l}
                                                                </td>
                                                            :
                                                                <td className={(list[0] === 'TOTAL PRUEBAS DIARIAS' ? j > 0 : j > 5) && 'center'} key={j}>
                                                                    {l}
                                                                </td>
                                                            }
                                                            </>
                                                        )}
                                                    </tr>
                                                )}
                                            </tbody>
										</table>
									</div>
									
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (EquipmentTest);